var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeVectorLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 171,
    height: 291,
    viewBox: "0 0 171 291",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-154.999 0.928423C-51.5822 282.727 136.22 386.259 2.79533 182.589C66.9549 240.47 184.76 216.335 167.046 118.097",
    stroke: "#413FE5",
    strokeWidth: 3.41966,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeVectorLeft);
export default __webpack_public_path__ + "static/media/home-vector-left.cba25b5818964446fc5f61e0e4ac1980.svg";
export { ForwardRef as ReactComponent };